import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import AppDialog from "~/shared/ui/AppDialog";
import { brl, joinIdsPt, plural } from "~/utils/format";
import { sendSummary } from "./vacancyState";

export default function SendPackageDialog({ open, packageId, rows, sending, refusalLabel, onCancel, onConfirm }) {
  const { go, no, goValue, goNotValidated, goWithoutDate, blockedWithoutDate } = sendSummary(rows);
  const blocked = blockedWithoutDate.length > 0;
  return (
    <AppDialog
      open={open}
      onClose={onCancel}
      busy={sending}
      size="sm"
      title={`Enviar pacote #${packageId} para o Antecipe?`}
      actions={
        <>
          <Button onClick={onCancel} disabled={sending} sx={{ color: "text.primary" }}>
            Voltar e revisar
          </Button>
          <LoadingButton variant="contained" loading={sending} disabled={blocked} onClick={onConfirm}>
            Enviar
          </LoadingButton>
        </>
      }
    >
      <Stack spacing={1}>
        <Typography>
          <b>{plural(go.length, "plantão segue", "plantões seguem")}</b> para análise do Antecipe ({brl(goValue)} em valor proporcional).
        </Typography>
        {no.length > 0 && (
          <Alert severity="warning">
            <b>{plural(no.length, "plantão não será antecipado", "plantões não serão antecipados")} agora</b> ({joinIdsPt(no.map((r) => r.id))}) e{" "}
            {no.length === 1 ? "vai" : "vão"} para um <b>novo pacote</b>, para você conferir depois. O número do pacote novo aparece assim que você confirmar.
            {refusalLabel && (
              <Box sx={{ mt: 0.5 }}>
                Motivo: <b>{refusalLabel}</b>
              </Box>
            )}
          </Alert>
        )}
        {goNotValidated.length > 0 && (
          <Alert severity="warning">
            {goNotValidated.length} dos plantões enviados {goNotValidated.length === 1 ? "está" : "estão"} com <b>valor não validado</b> e{" "}
            {goNotValidated.length === 1 ? "vai" : "vão"} parar na análise do Antecipe até a revisão.
          </Alert>
        )}
        {goWithoutDate.length > 0 && (
          <Alert severity="error">
            {plural(goWithoutDate.length, "plantão está", "plantões estão")} sem data de pagamento normal. O Antecipe precisa dela para calcular a taxa.
            {blocked && (
              <Box sx={{ mt: 0.5 }}>
                Preencha a data {blockedWithoutDate.length === 1 ? "do plantão" : "dos plantões"} {joinIdsPt(blockedWithoutDate.map((r) => r.id))} para enviar.
              </Box>
            )}
          </Alert>
        )}
      </Stack>
    </AppDialog>
  );
}
